import { Component, OnInit } from "@angular/core";
import { TournamentData } from "app/models";
import { DrawingsService, NotificationService } from "app/services";
import { TournamentService } from "app/services/tournament.service";

@Component({
    selector: 'admin-carousel',
    templateUrl: 'carousel.page.html',
    styleUrls: ['carousel.page.scss'],
})
export class AdminDrawingCarousel implements OnInit {
    data: TournamentData | undefined;
    
    isProcessing: boolean = false;

    constructor(private tournamentService: TournamentService, private notificationService: NotificationService,
        private drawingService: DrawingsService) {}
    
    ngOnInit(): void {
        this.loadData();
    }

    createTournament() {
        this.isProcessing = true;

        this.drawingService.createCarousel()
            .subscribe(result => {
                this.notificationService.showSuccess('Турнир создан успешно');
                this.loadData();
            }, error => {
                this.notificationService.showSuccess('Не удалось создать турнир');
                this.isProcessing = false;
            })
    }

    private loadData() {
        this.tournamentService.getCarouselData()
            .subscribe(result => {
                this.data = result;
                this.isProcessing = false;
            }, error => {
                this.notificationService.showError('Не удалось загрузить данные о турнире.');
            })
    }
}